import { useState, useEffect, useRef } from 'react';
import "./MediaUploader.css";
import Modal from "../shared/Modal";
import toast from 'react-hot-toast';
import { toastFail, toastSuccess } from '../../config';
import { postImage } from '../../services/client';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/features/appData';
import { apiCreateAssetInWorkspace } from '../../services/AssetService';
import { Asset, CreateAssetInWorkspacePayload } from 'effno-core';

type MediaUploaderProps = {
    onSelectedAsset: (asset: Asset) => void;
}

export const MediaUploader = ({onSelectedAsset} : MediaUploaderProps) => {

    const storeUser = useSelector(selectUser);
    
    const imageRef = useRef(null);
    const [filename, setFilename] = useState<string>("");

    const handlePickFile = () => {
        if (imageRef?.current) {
          const inputButton : any = imageRef.current;
          setFilename("");
          inputButton.click();
        }
    };

    const handleFileChange = (event: any) => {
        if (event.target.files && event.target.files?.length < 1) {
            return;
          }
      
        if (event.target.files && event.target.files[0].size > 10485760) {
            toast("Avatar is too big! Please keep it under 10MB", toastFail);
            return;
        }
    
        const theFile = event.target.files ? event.target.files[0] : null;
    
        if (!theFile) {
            toast("Did not get a valid file", toastFail);
            return;
        }

        // alert("File selected: " + theFile.name);

        setFilename(theFile.name);
        console.log("[MediaUploader] handleFileChange", theFile);

        (async () => {
            if (!storeUser || !storeUser.currentWorkspaceId) {
                toast("User not found, please log in again.", toastFail);
                return;
            }

            toast("Uploading...", toastSuccess);
      
            try {
              const response = await postImage(storeUser.currentWorkspaceId, theFile, () => {});

              if (!response) {
                toast("Could not upload file, please try again.", toastFail);
                return;
              }
      
              if (response.status === 200) {

                const uploadedFileURL = response.data.data;
                const payload : CreateAssetInWorkspacePayload = {
                    workspaceId: storeUser.currentWorkspaceId,
                    URL: uploadedFileURL,
                }

                const asset = await apiCreateAssetInWorkspace(payload);

                if (!asset) {
                    toast("Could not create asset, please try again.", toastFail);
                    return;
                }
                
                onSelectedAsset(asset);

              } else {
                toast("File not uploaded: " + response.status, toastFail);
              }
            } catch (error) {
              // Handle error
              toast("Error uploading file, please try again.", toastFail);
            }
          })();
    }

    return (
       
        <div className="media-uploader">
            <div className="media-uploader-title">
                <a onClick={handlePickFile}>Upload</a>&nbsp;a file
            </div>

            <div className="media-manager-content">
                JPG, PNG, SVG, GIF (max 10MB)
            </div>

            <input
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/gif"
                ref={imageRef}
                style={{ display: "none" }}
                value=""
                onChange={handleFileChange}
                onError={(event) => console.log("onError", event)}
            />
        </div>
    )
}
